import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { next } from '../../../store/onboarding.duck';
import { Column, Row } from '@shared/ui/atoms/StructuralLayout';
import { HeadlineLarge } from '@shared/ui/atoms/fonts/Headline';
import { BodyLarge } from '@shared/ui/atoms/fonts/Body';
import {
  setHolidayYearRecurringDay,
  setHolidayYearRecurringMonth
} from '@features/settings/pages/edit-company-page/editCompany.duck';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import {
  StartDateDropDown
} from "@features/settings/pages/holiday-settings-page/HolidayYearSetting";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { capitalizeFirstLetter } from "@shared/utils/ArrayUtils";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function SetupHolidayRules() {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const MONTHS = useMemo(() => {
    const date = moment(0);
    return [
      { name: capitalizeFirstLetter(date.format('MMMM')), id: 1 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 2 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 3 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 4 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 5 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 6 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 7 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 8 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 9 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 10 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 11 },
      { name: capitalizeFirstLetter(date.month(date.month() + 1).format('MMMM')), id: 12 },
    ]
  }, []);

  const START_OPTIONS = useMemo(() => {
    return [
      { name: t('general.first-monday'), id: 0 },
      { name: t('general.first-day'), id: 1 },
    ];
  }, [t]);

  return (
    <div className="onboarding">
      <Column className="onboarding__content">
        <HeadlineLarge style={{marginBottom: 12}}>{t('settings.holiday-rules')}</HeadlineLarge>
        <BodyLarge style={{marginBottom: 16}}>{t('settings.holiday-year-start-message')}</BodyLarge>

        <Row>
          <StartDateDropDown items={START_OPTIONS}
                             onSelect={(v: any) => dispatch(setHolidayYearRecurringDay(v))}
                             selectedId={0}
                             placeholder="textinput.select-start-day"/>
        </Row>
        <Row>
          <StartDateDropDown items={MONTHS}
                             onSelect={(v: any) => dispatch(setHolidayYearRecurringMonth(v))}
                             selectedId={1}
                             placeholder="textinput.select-month"/>
        </Row>

        <PrimaryButton dataTest="onboarding-hotDesking-next"
                       size={ButtonSize.Large}
                       text="button.done"
                       click={() => dispatch(next())}
                       fullWidth={true}/>
      </Column>
    </div>
  )
}
